export default __webpack_public_path__ + "static/media/ansible.26780715.svg";